module.exports = __webpack_public_path__ + "img/cas1.17b8fcac.png";